import { map } from 'rxjs/operators';
import ApiService from './api';
import { PublicError } from '../error';

const validateAuth = (reponse) => {
  if (reponse.error) {
    throw new PublicError(reponse.message, reponse.error);
  }

  return reponse;
};

export default class AuthService extends ApiService {
  loadLoggedUser() {
    return this
      .fetchResource('/currentUser')
      .pipe(
        map(user => ({ user })),
      );
  }

  init() {
    return this
      .fetchResource('/login')
      .pipe(
        map(({ salt }) => ({ salt })),
      );
  }

  login(credentials) {
    return this
      .fetchResource('/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      })
      .pipe(
        map(validateAuth),
        map(user => ({ user })),
      );
  }

  logout() {
    return this
      .fetchResource('/logout', {
        method: 'POST',
      });
  }
}
